import get from 'lodash/get';

export function getVisitFormOptions(list, isComplexName) {
  return list.map(item => {
    const label = isComplexName
      ? `${get(item, 'firstName')} ${get(item, 'lastName')}`
      : get(item, 'name');

    return {
      label,
      value: get(item, 'id'),
    };
  });
}



// WEBPACK FOOTER //
// ./src/components/VirtualVisit/utils/getVisitFormData.js